import FileExplorerLayout from '../Components/FileExplorerLayout';

function BookmarksPage() {
  return <FileExplorerLayout />;
}

export default BookmarksPage;
